import * as React from 'react';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';
import cl from 'classnames';

import { IconSystemV2CourseArrowChevronDownArrowDown } from '@doltech/icons/SystemV2/IconSystemV2CourseArrowChevronDownArrowDown';
import { useSimpleAudioPlayInBackgroundStore } from '@doltech/ui/lib/hooks/simple-audio-play-in-background.store';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { shadows } from '@doltech/ui/lib/figma/shadows';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { LineDivider } from '@doltech/ui/lib/figma/Divider/LineDivider';
import { ExpandCollapseAnimation } from '@doltech/ui/lib/examples/Animation/ExpandCollapse';

import { PopularWordModel } from '../../../shared/types/dictation-types';
import { VocabContentItem } from '../../../shared/ui/VocabContentItem/VocabContentItem';

const Main = styled.div`
  border-radius: 8px;
  overflow: hidden;
  box-shadow: ${shadows.zIndex1};
`;

const Header = styled.div`
  background-color: ${colorsV2.white100};
  padding: 16px 20px;
  border-radius: 12px 12px 0 0;

  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  &.expanded {
    box-shadow: ${shadows.border1Bottom};
    svg {
      transform: rotate(180deg);
      transition: transform 0.2s;
    }
  }
`;

const Content = styled.div`
  padding: 0 20px;
  background-color: ${colorsV2.white100};
`;

interface SectionHighlightVocabularyProps {
  popularWords: PopularWordModel[];
  onStartPronunciation?: (wordIndex: number) => void;
}
export const SectionHighlightVocabulary = observer((props: SectionHighlightVocabularyProps) => {
  const { popularWords, onStartPronunciation } = props;
  const [expanded, setExpanded] = React.useState(false);
  const audioStore = useSimpleAudioPlayInBackgroundStore();

  return (
    <Main className="section-view-script-detail-layout">
      <Header onClick={() => setExpanded((o) => !o)} className={cl({ expanded })}>
        <ResponsiveTypography.Paragraph variant="semi-bold/16-24">
          Từ hay học được
        </ResponsiveTypography.Paragraph>
        <IconSystemV2CourseArrowChevronDownArrowDown size={24} color="black60" />
      </Header>
      <ExpandCollapseAnimation expanded={expanded}>
        <Content>
          {popularWords?.map((singleWord, wordIndex, arr) => {
            const { key, enWord, viWord, pronunciation, isLearnedPopularWordPronun } = singleWord;
            const isLast = wordIndex === arr.length - 1;
            return (
              <React.Fragment key={key}>
                <VocabContentItem
                  enWord={enWord}
                  viWord={viWord}
                  pronunciation={pronunciation}
                  onStartPronunciation={() => onStartPronunciation?.(wordIndex)}
                  onPlayText={() => audioStore.playByText(enWord)}
                  isLearned={isLearnedPopularWordPronun}
                  audioPlaying={audioStore.playing && audioStore.playingValue === enWord}
                />
                {!isLast && <LineDivider size={1} space={0} color={colorsV2.gray20} />}
              </React.Fragment>
            );
          })}
        </Content>
      </ExpandCollapseAnimation>
    </Main>
  );
});
